var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "label-create-form-data" }, [
        _vm._v("CREATE SINGLE EXPERIENCE MANAGER")
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "div",
              [
                _c(
                  "b-form-group",
                  { class: { "error-input": _vm.$v.dataForm.name.$error } },
                  [
                    _c("label", { attrs: { for: "name" } }, [_vm._v(" Name ")]),
                    _vm._v(" "),
                    _c("j-input", {
                      attrs: { id: "name", placeholder: "Enter name here" },
                      model: {
                        value: _vm.$v.dataForm.name.$model,
                        callback: function($$v) {
                          _vm.$set(_vm.$v.dataForm.name, "$model", $$v)
                        },
                        expression: "$v.dataForm.name.$model"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "float-right" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn m__r--5",
                          on: { click: _vm.closeModal }
                        },
                        [_vm._v("\n              Close\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "btn blue",
                          on: { click: _vm.submitForm }
                        },
                        [_vm._v("\n              Next\n            ")]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76cbefb3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76cbefb3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager/jFormUiCreate.vue
// module id = null
// module chunks = 